export default __webpack_public_path__ + "src/appV2/redesign/NursesWeekNomination/assets/images/goldTrophy.png";